export default {
  title: 'Consommation',
  footnote:
    'La diffusion est comptée en gigaoctets décimaux (1 Go = 1 000 000 000 octets) ; la lecture depuis Videas n’est ni comptée ni facturée.',
  periods: {
    label: 'Période',
    week: '7 jours',
    month: 'Ce mois-ci',
    previousMonth: 'Mois dernier',
    quarter: '3 mois',
  },
  modes: {
    label: 'Afficher',
    euros: 'En euros',
    volumes: 'En volumes',
  },
  kpi: {
    total: 'Total de la période',
    projection: 'fin de mois estimée ≈ {amount}',
    delivered: 'Diffusé sur la période',
    delivery: 'Diffusion incluse ce mois-ci',
    deliveryOf: 'sur {included}',
    deliveryNone: 'Rien de diffusé ce mois-ci',
    // A month with no free delivery (`delivery.ts`' `franchiseOf`): never paid, or paid during it.
    deliveryNeverPaid: 'Aucune ce mois-ci : la diffusion offerte vient avec le mois qui suit votre première recharge.',
    deliveryFrom: 'Aucune ce mois-ci : la diffusion offerte commence le {date}.',
    stored: 'Stocké aujourd’hui',
    storedRate: '≈ {amount} par jour',
  },
  chart: {
    title: 'Jour par jour',
    hint: 'Survolez une barre pour le détail du jour.',
    empty: 'Aucune consommation sur cette période.',
    label: 'Consommation par jour',
    meters: {
      bandwidth: 'Diffusion',
      video: 'Vidéo stockée',
      files: 'Fichiers stockés',
    },
  },
  table: {
    service: 'Service',
    volume: 'Volume',
    rate: 'Tarif actuel',
    cost: 'Coût',
    total: 'Total',
    included: 'Inclus',
    services: {
      subscriptions: 'Chaîne et domaine',
      video: 'Stockage vidéo',
      files: 'Stockage fichiers',
      videoFirstMonth: 'Premier mois de stockage vidéo',
      filesFirstMonth: 'Premier mois de stockage fichiers',
      subtitles: 'Sous-titres automatiques',
      delivery: 'Diffusion',
      other: 'Autres',
    },
    subscriptionsVolume: '{count} abonnement | {count} abonnements',
    subscriptionsRate: '{amount} par mois chacun',
    // Video storage billed by the bytes of the videos' sources (`docs/plans/org-pricing.md` OP6).
    videoBySources: 'Au Go de leurs sources, sur la ligne des fichiers',
    storedOn: '{volume} le {date}',
    deliveryRate: '{included} inclus par mois, puis {rate}',
    deliveryRateNeverPaid: '{rate} dès le premier Go ; {included} inclus par mois à partir du mois qui suit votre première recharge',
    deliveryRateFrom: '{rate} dès le premier Go ce mois-ci ; {included} inclus par mois à partir du {date}',
  },
  // Keyed on the priced unit the server serves on each usage row (`priced_unit`).
  units: {
    gigabyte: 'Go',
    hour: 'h',
    minute: 'min',
  },
}
